import React, { useEffect, useState } from "react";
import { Spin, Card, Row, Button } from "antd";

import { FONT, USER_STORAGE } from "constants/index";
import FormLoadUserComparation from "./load-control-drawer-comparation";
import { getById } from "services/user/user-service";
import FormNewUserControl from "./load-control-drawer-new-control";
import DrawerApp from "components/drawer-app";
import {
  getControlByUser,
  getControlByUserBoot,
} from "services/control/control-service";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { notificationErroInternal } from "util/api-utils";
import useBreakpoint from "hooks/useBreakpoint";
import { drawerWidth } from "util/responsive";

dayjs.extend(customParseFormat);
const dateFormatIso = "YYYY-MM-DD";

const LoadControlClientUser = () => {
  const { isMobile } = useBreakpoint();
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const [isBoot, setIsBoot] = useState(null);
  const [open, setOpen] = useState(false);
  const [userControl, setUserControl] = useState({});
  const [nowControl, setNowControl] = useState({});
  const [userData, setUserData] = useState({});

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { id } = JSON.parse(localStorageItem);
      getById(id).then((res) => {
        setIsBoot(res.isBoot);
        setUserId(id);
        setUserData({ id, img: res.img, name: res.name });
        getData(id, res.isBoot);
      });
    }
  }, [localStorage.getItem(USER_STORAGE)]);

  const onClose = () => {
    setOpen(false);
  };

  function getData(id, boot) {
    setLoading(true);
    const funcGet = boot == true ? getControlByUserBoot : getControlByUser;
    funcGet(id)
      .then((res) => {
        const date = dayjs(new Date());
        const dateString = date.format(dateFormatIso);
        const todayControl = res?.controlActual?.controls?.find(
          (item) => item.date == dateString
        );
        setNowControl(todayControl);
        setUserControl(res);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  const handleSaved = () => {
    getData(userId, isBoot);
    onClose();
  };

  return (
    <div className="container-load-client">
      <Spin size="large" spinning={loading}>
        <Card style={{ backgroundColor: "#ffffff" }}>
          <Row style={{ margin: 5 }} justify="end">
            <Button
              style={{
                fontFamily: FONT,
                background: "#14B8A6",
                color: "#ffffff",
              }}
              onClick={() => setOpen(true)}
            >
              Registrar Controle
            </Button>
          </Row>
          <FormLoadUserComparation userId={userId} isBoot={isBoot} />
        </Card>
      </Spin>

      <DrawerApp
        open={open}
        onClose={onClose}
        title={"Registrar Controle"}
        body={
          <FormNewUserControl
            user={{
              ...userData,
              name: userControl.name ?? userData.name,
            }}
            nowControl={nowControl}
            userId={userId}
            isBoot={isBoot}
            reviewId={userControl.controlActual?.reviewId}
            onClose={onClose}
            onSaved={handleSaved}
          />
        }
        size={"large"}
        isOnlyView={true}
        width={drawerWidth(isMobile, 60)}
      />
    </div>
  );
};
export default LoadControlClientUser;
